import * as React from 'react';
import { Box, Typography } from '@mui/material';
import InformationalLayout from './InformationalLayout';

function Pricing() {
    return (
        <InformationalLayout
            title="Simple, Transparent Pricing"
            subtitle="Choose the plan that works for your adventures"
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                backgroundColor: 'rgba(248, 249, 250, 0.95)',
                borderRadius: 2,
                p: 4
            }}>
                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="h4" gutterBottom sx={{ color: '#2c3e50' }}>
                        Pricing Coming Soon
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#6c757d', mb: 3 }}>
                        We're working on flexible pricing options
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#6c757d' }}>
                        In the meantime, enjoy full access to all features during our beta period
                    </Typography>
                </Box>
            </Box>
        </InformationalLayout>
    );
}

export default Pricing;